import { useCallback, useMemo } from 'react';

import { useGenerateStrategicPlan } from '@/api/generated';

const useGeneratePlan = () => {
  const {
    mutate: generate,
    isPending: isGenerating,
    data: generateData,
    reset: resetGenerateMutation,
    isError: isGenerateError
  } = useGenerateStrategicPlan();

  const generatedStrategicPlan = useMemo(
    () => generateData?.items?.[0]?.plan || null,
    [generateData]
  );

  const generateStrategicPlan = useCallback(
    (goals: string[]) => {
      generate({
        data: {
          goals
        }
      });
    },
    [generate]
  );

  return {
    generateStrategicPlan,
    isGenerating,
    generatedStrategicPlan,
    resetGenerateMutation,
    isGenerateError
  };
};

export default useGeneratePlan;
